import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { ExpandCollapse } from '../../../components/ExpandCollapse/ExpandCollapse';
import { RichEditor } from '../../../components/RichEditor';
import type { QuestionStore } from '../store';

export const QuestionEditor = observer(
	({ store, readOnly }: { readOnly: boolean; store: QuestionStore }) => {
		const handleChange = useCallback(
			(value: string | undefined) => {
				store.update({ definition: value ?? '' });
			},
			[store]
		);

		return (
			<ExpandCollapse maxHeight={400}>
				<RichEditor
					emptyDocPlaceholder="Add description..."
					initialValue={store.question.definition}
					onChangeCallback={handleChange}
					readOnly={readOnly}
					disableTopGap
					enableScrollToHash
				/>
			</ExpandCollapse>
		);
	}
);
